import { Tag } from '@bedrock/components'
import React from 'react';

const ActualExecutionTag = (props) => {
  const { value, style, className } = props;
  if (typeof value !== 'boolean') {
    return null;
  }
  
  if (value) {
    return null;
    // return (
    //   <Tag text='执行' color='green' size='xSmall' style={style} />
    // )
  }

  return <Tag text='不执行' color='grey' size='xSmall' style={style} className={className} />
}

export default ActualExecutionTag
